import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("fn_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Auth
export async function apiRegister(email, password, name) {
  const { data } = await axios.post(`${API}/auth/register`, { email, password, name });
  return data;
}
export async function apiLogin(email, password) {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  return data;
}
export async function apiMe() {
  const { data } = await axios.get(`${API}/auth/me`);
  return data.user;
}
export async function apiLogout() {
  await axios.post(`${API}/auth/logout`);
}

// Grids
export async function generateGrid(topic, path, force = false) {
  const { data } = await axios.post(`${API}/generate`, { topic, path, force });
  return data;
}
export async function generateFromNotes(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(`${API}/generate-from-notes`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

// Maps
export async function saveMap(payload) {
  const { data } = await axios.post(`${API}/maps`, payload);
  return data;
}
export async function shareMap(id) {
  const { data } = await axios.post(`${API}/maps/${id}/share`);
  return data.share_id;
}
export async function getPublicMap(shareId) {
  const { data } = await axios.get(`${API}/public/maps/${shareId}`);
  return data;
}
export async function listMaps() {
  const { data } = await axios.get(`${API}/maps`);
  return data.maps;
}
export async function getMap(id) {
  const { data } = await axios.get(`${API}/maps/${id}`);
  return data;
}
export async function deleteMap(id) {
  await axios.delete(`${API}/maps/${id}`);
}

// Cell image (Unsplash, cached globally by query)
export async function getCellImage(query) {
  const { data } = await axios.get(`${API}/cell-image`, { params: { query } });
  return data;
}

// Payments
export async function createCheckout(plan = "monthly") {
  const { data } = await axios.post(`${API}/payments/checkout`, { origin_url: window.location.origin, plan });
  return data;
}
export async function paymentStatus(sessionId) {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
}

// Spaced review
export async function gradeReview(payload) {
  const { data } = await axios.post(`${API}/reviews/grade`, payload);
  return data;
}
export async function getDueCards() {
  const { data } = await axios.get(`${API}/reviews/due`);
  return data;
}

// Subscription management
export async function getSubscription() {
  const { data } = await axios.get(`${API}/subscription`);
  return data;
}
export async function cancelSubscription() {
  const { data } = await axios.post(`${API}/subscription/cancel`);
  return data;
}
export async function resumeSubscription() {
  const { data } = await axios.post(`${API}/subscription/resume`);
  return data;
}
export async function switchPlan(plan) {
  const { data } = await axios.post(`${API}/subscription/switch`, { plan });
  return data;
}
